export default {
  label: {
    sentimentIndex: 'Índice de sentimiento',
    engagementIndex: 'Índice de compromiso',
  },
};
